import { Component } from '@ecs/Component';

export class Torpedo implements Component {
  readonly type = 'Torpedo';

  constructor(
    public targetEntityId: number | null = null,
    public turnRate: number = 0.1, // Slightly faster turning
    public maxSpeed: number = 3.5, // Slightly faster max speed
    public acceleration: number = 0.15, // Faster acceleration
    public currentSpeed: number = 1.5, // Higher initial speed
    public damage: number = 1
  ) {}
}